import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  { name: "James W.", country: "🇺🇸 USA", profit: "$12,400", text: "Made my first withdrawal within 7 days. Incredible platform with real results.", rating: 5 },
  { name: "Amara O.", country: "🇬🇧 UK", profit: "$8,750", text: "I was skeptical at first, but Prime Profit delivered exactly what they promised.", rating: 5 },
  { name: "Chen L.", country: "🇸🇬 Singapore", profit: "$23,000", text: "The 7-day trading cycle is genius. My portfolio has grown consistently every week.", rating: 5 },
  { name: "Sofia M.", country: "🇪🇸 Spain", profit: "$5,200", text: "Easy to use, fast withdrawals, and the support team is always available.", rating: 5 },
  { name: "David K.", country: "🇩🇪 Germany", profit: "$15,600", text: "Best crypto investment platform I've used. Transparent and trustworthy.", rating: 5 },
  { name: "Fatima A.", country: "🇦🇪 UAE", profit: "$31,000", text: "Started with £2,000 and now I'm earning consistently every cycle.", rating: 5 },
  { name: "Marcus J.", country: "🇨🇦 Canada", profit: "$9,800", text: "The risk management tools gave me confidence to invest more.", rating: 4 },
  { name: "Yuki T.", country: "🇯🇵 Japan", profit: "$18,500", text: "Zero fees on withdrawals is a game changer. Highly recommend.", rating: 5 },
  { name: "Oluwaseun B.", country: "🇳🇬 Nigeria", profit: "$7,300", text: "Prime Profit changed my financial life. Consistent returns every week.", rating: 5 },
  { name: "Elena R.", country: "🇮🇹 Italy", profit: "$11,200", text: "Professional platform with excellent customer service. 5 stars!", rating: 5 },
  { name: "Robert H.", country: "🇦🇺 Australia", profit: "$28,000", text: "I've tried many platforms. Prime Profit is the only one that delivers.", rating: 5 },
  { name: "Priya S.", country: "🇮🇳 India", profit: "$6,400", text: "The expert trading team knows exactly when to enter and exit positions.", rating: 4 },
  { name: "Mohammed Z.", country: "🇸🇦 Saudi Arabia", profit: "$42,000", text: "Invested £10,000 and received my capital plus profit in exactly 7 days.", rating: 5 },
  { name: "Anna P.", country: "🇵🇱 Poland", profit: "$8,100", text: "User-friendly interface and the returns are better than any bank.", rating: 5 },
  { name: "Lucas F.", country: "🇧🇷 Brazil", profit: "$13,700", text: "Fast withdrawals, no hidden fees. This is how investing should be.", rating: 5 },
  { name: "Grace N.", country: "🇰🇪 Kenya", profit: "$4,900", text: "Started small and grew my investment steadily. Amazing platform!", rating: 5 },
  { name: "Thomas B.", country: "🇫🇷 France", profit: "$19,300", text: "The transparency of Prime Profit sets it apart from competitors.", rating: 5 },
  { name: "Sarah L.", country: "🇿🇦 South Africa", profit: "$10,500", text: "My third cycle and every single one has been profitable. Unbelievable.", rating: 5 },
  { name: "Kevin C.", country: "🇮🇪 Ireland", profit: "$7,800", text: "Withdrew my profits within hours. No delays, no excuses. Just results.", rating: 4 },
  { name: "Maria G.", country: "🇲🇽 Mexico", profit: "$16,200", text: "Prime Profit is the real deal. Secure, reliable, and highly profitable.", rating: 5 },
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-card/30">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-display text-3xl font-bold gradient-gold-text md:text-4xl">
            What Our Investors Say
          </h2>
          <p className="mt-4 text-muted-foreground font-body text-lg">
            Real stories from real investors earning with Prime Profit
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 8) * 0.05 }}
              className="rounded-xl border border-gold-dark/30 bg-card p-5 transition-all hover:border-gold/50"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star
                    key={s}
                    className={`h-4 w-4 ${s < t.rating ? "fill-gold text-gold" : "text-muted-foreground/30"}`}
                  />
                ))}
              </div>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                "{t.text}"
              </p>
              <div className="mt-4 flex items-center justify-between">
                <div>
                  <p className="font-display text-sm font-semibold text-foreground">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.country}</p>
                </div>
                <span className="font-display text-sm font-bold text-gold">+{t.profit}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
